import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Explore from '@/components/explore'
import Support from '@/components/support'
import Lab from '@/components/the-lab'
import DynamicStories from '@/components/dynamic'

Vue.use(Router)

const routes = [
  { path: '/', component: Home },
  { path: '/explore', component: Explore },
  { path: '/support-us', component: Support },
  { path: '/the-lab', component: Lab },
  { path: '/dynamic-stories', component: DynamicStories }
]

const router = new Router({
  routes: routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  meta: {
    progress: {
      func: [
        {call: 'color', modifier: 'temp', argument: '#ffb000'},
        {call: 'fail', modifier: 'temp', argument: '#6e0000'},
        {call: 'location', modifier: 'temp', argument: 'top'},
        {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
      ]
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js